<template>
	<div class="page" style=" overflow: auto;">

		<van-cell-group>
			<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
				<span class="rowlabel"></span>视频报送审核
			</div>

			<van-field readonly v-model="stuForm.stu_name" label="考生姓名" label-width="110px" />
			<van-field readonly v-model="stuForm.exam_num" label="考生准考证号" label-width="110px" />
			<van-field readonly v-model="stuForm.flag" style="color: #007AFF;" label="报考专业" label-width="110px">
				<template #input>
					<div style="color: #007AFF;">
						<span>{{stuForm.major_name}}[{{stuForm.xuezhi}}]</span>
					</div>

				</template>
			</van-field>
			<van-field readonly v-model="stuForm.flag" style="color: #007AFF;" label="视频（作品）报送状态" label-width="110px">
				<template #input>
					<div style="color: #007AFF;">
						<span v-if="!stuForm.flag">未审核</span>
						<span v-else>
							<strong v-if="stuForm.flag.indexOf('不符合')>0" style="color: orangered;">{{stuForm.flag}}</strong>
							<strong v-else>{{stuForm.flag}}</strong>
						</span>

					</div>

				</template>
			</van-field>
			<van-field  v-if="stuForm.flag_remark"  readonly v-model="stuForm.flag" style="color: #007AFF;" label="视频（作品）报送详细" label-width="110px">
				<template #input>
					<div style="color: orangered;">
						{{stuForm.flag_remark}}
			
					</div>
			
				</template>
			</van-field>
			<div style="height: 50px;">
				
			</div>
			<van-field v-if="stuForm.major_name2" readonly v-model="stuForm.flag" style="color: #007AFF;" label="兼报专业" label-width="110px">
				<template #input>
					<div style="color: #007AFF;">
						<span>{{stuForm.major_name2}}[{{stuForm.xuezhi2}}]</span>


					</div>

				</template>
			</van-field>
			<van-field  v-if="stuForm.major_name2"  readonly v-model="stuForm.flag" style="color: #007AFF;" label="视频（作品）报送状态" label-width="110px">
				<template #input>
					<div style="color: #007AFF;">
						<span v-if="!stuForm.flag2">未审核</span>
						<span v-else>
							<strong v-if="stuForm.flag2.indexOf('不符合')>0" style="color: orangered;">{{stuForm.flag2}}</strong>
							<strong v-else>{{stuForm.flag2}}</strong>
						</span>

					</div>

				</template>
			</van-field>
			<van-field  v-if="stuForm.flag_remark2"  readonly v-model="stuForm.flag2" style="color: #007AFF;" label="视频（作品）报送详细" label-width="110px">
				<template #input>
					<div style="color: orangered;">
						{{stuForm.flag_remark2}}
			
					</div>
			
				</template>
			</van-field>
			
			
		</van-cell-group>
		<!-- <div v-if="stuForm.flag!='视频接收成功、视频报送符合要求'"  style="width: 50%; margin: 0 auto; text-align: center; padding-top: 100px;">
			<el-button size="small" type="primary" style="width: 100%;" @click="saveForm">保存 <i class="el-icon-right" ></i></el-button>
		</div> -->



	</div>
</template>

<script>
	import {
		Dialog,
		Toast,
		Uploader
	} from 'vant';
	export default {
		data() {
			return {

				stuForm: {
					ly_type: "",
					stu_name: "",
					archive: "",
					identity_card: "",
					phone: "",
					gender: "",
					exam_score: "",
					graduate_sch_city: "",
					graduate_schid: -1,
					graduate_schname: "",
					graduate_schname2: "",
					graduate_dist_code: "",
					major_id: "",
					major_id2: '',
					major_id3: '',
					major_name: "",
					major_name2: "",
					major_name3: "",
					volunteer: '',
					volunteerTxt: "",
					oldname: '',
					exam_num: '',
					remark: "",
					jhr1name: "",
					jhr1phone: "",
					jhr2name: "",
					jhr2phone: "",
					minzu: "",
					zzmm: "",
					jiguan: "",
					hkszd: "",
					hkszdpcs: "",
					hkxz: "",
					jzdtype: "",
					jtzz: "",


				},

			}
		},
		mounted() {
			$(".page").height($(window).height())
			document.title = "线上专业考试视频（作品）报送情况"
			this.pmid = this.$route.query.pmid
			this.openid = this.$route.query.openid
			if (!this.openid) {
				Dialog.alert({
					title: '网络错误',
					message: '未获取到微信授权用户信息，请重新扫码！',
					theme: 'round-button',
				}).then(() => {
					// on close
				});
			} else {
				window.pmid = this.pmid
				this.getStudents()

			}





		},
		methods: {

			getStudents() {

				this.$http.post("/api/app_stupre_info", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {
					if (res.data) {


						res.data.otherjson = JSON.parse(res.data.otherjson)
						this.stuForm = res.data

					} else {
						Dialog.alert({
							title: '提示',
							message: '未找到报名信息！',
							theme: 'round-button',
						}).then(() => {
							// on close
						});
					}



				})
			},

		},
	}
</script>
<style type="text/css" scoped="scoped">
	.rowlabel {
		display: inline-block;
		width: 6px;
		border-radius: 3px;
		height: 14px;
		float: left;
		background: #1283ff;
		vertical-align: middle;
		transform: translateY(2px);
		margin-right: 5px;
	}
</style>
